import { render } from "./HowItWorks.vue?vue&type=template&id=74473701"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\dividenduitkering\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__